import service from './service'
import { CONTENT_TYPE, TOKEN_KEY } from '@/constants'

const request = (option: AxiosConfig) => {
  const { url, method, params, data, headers, responseType, timeout } = option

  const token = sessionStorage.getItem(TOKEN_KEY)
  const headerObj: Record<string, string> = {
    'Content-Type': CONTENT_TYPE,
  }
  if (token) {
    headerObj['Authorization'] = `Bearer ${token}`
  }

  return service.request({
    url: url,
    method,
    params,
    data: data,
    responseType: responseType,
    timeout,
    headers: {
      ...headerObj,
      ...headers,
    },
  }) as Promise<IResponse>
}

export { request }

export default {
  get: <T = any>(option: AxiosConfig) => {
    return request({ method: 'get', ...option }) as Promise<IResponse<T>>
  },
  post: <T = any>(option: AxiosConfig) => {
    return request({ method: 'post', ...option }) as Promise<IResponse<T>>
  },
  delete: <T = any>(option: AxiosConfig) => {
    return request({ method: 'delete', ...option }) as Promise<IResponse<T>>
  },
  put: <T = any>(option: AxiosConfig) => {
    return request({ method: 'put', ...option }) as Promise<IResponse<T>>
  },
  cancelRequest: (url: string | string[]) => {
    return service.cancelRequest(url)
  },
  cancelAllRequest: () => {
    return service.cancelAllRequest()
  },
}
